import React from "react";
import Layout from "../Layout";
import AddScriptWidget from "../../../widgets/management/add-script/AddScript";

function AddScript(props) {
  return (
    <Layout>
      <AddScriptWidget />
    </Layout>
  );
}

export default AddScript;
